import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { getLocationLanguageParam } from '../Utils/getLocationLanguageParam';
function isProduction() {
  // eslint-disable-next-line no-undef
  return process.env.NODE_ENV === 'production';
}
const lang = getLocationLanguageParam();
const loadPath = isProduction()
  ? `/frontendapi/translations/frontend/${lang}`
  : '/translations_custom/' + lang + '.json';
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(HttpApi)
  .init({
    lng: lang,
    fallbackLng: 'en_GB',
    load: 'currentOnly',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: loadPath,
      crossDomain: true,
    },
  });

export default i18n;
